import { PluginKey } from '@tiptap/pm/state'

/** Shared keys so EditorRoot can read suggestion `active` state (must match Mention.configure pluginKey). */
export const userMentionsPluginKey = new PluginKey('userMentions')
export const hashMentionsPluginKey = new PluginKey('hashMentions')
